import React, {useEffect, useState} from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import * as globalActions from 'ui/containers/App/actions';
import * as globalSelectors from 'ui/containers/App/selectors';
import InsentLink from 'ui/components/InsentLink';
import AgentCard from 'ui/components/AgentCard';
import Card from 'ui/components/Card';
import MessageInput from 'ui/components/MessageInput';
import MoreOptions from "../../components/MoreOptions";
import DOMPurify from 'dompurify';
import {
  HomeContainer,
  HomeHeader,
  HomeHeaderCoyLogo,
  HomeHeaderCoyLogoWrapper,
  HomeHeaderTitle,
  HomeHeaderSubtitle,
  HomeConversation,
  HomeConversationHeader,
  HomeConversationList,
  NotificationContainer,
  HomeBackgroundSVG,
  HomeBg,
  NoConversation,
  HeaderLogoContainer,
  LoaderCardWrapper,
} from './common';
import PageLoader from 'ui/components/Loaders/PageLoader';
import {MOMENT_STRINGS, MOMENT_TIME_LIMIT, PAGE} from 'common/constants';
import NativeNotification from 'ui/components/NativeNotification';
import { eventTypes } from 'utils/eventTypes';
import {getFromLocalStorage, saveEventToLocalStorage, saveToLocalStorage} from 'utils/saveToLocalStorage';
import localStorageTemplates from 'common/local-storage-templates';
import {
  AllFilesFooter,
  AllFilesHeader, AllFilesHeaderText, AllFilesListContainer,
  AZoomInfoCompany,
  ConversationBackButton,
  ConversationBackIcon,
  ConversationHeader,
  TypingIndicator
} from "../Conversation/common";
import AllFilesBackIcon from "../../../assets/icons/back-all-files.svg";
import {ReactComponent as AllFiles} from "../../../assets/icons/allfiles.svg";
import moment from "moment";
import Moment from "react-moment";
import FileItem from "../../components/FileItem";
import theme from "../../../styles/theme";
import styled from "styled-components";
import {slideUp} from "../../../styles/animation";
import MessageContainer from "../../components/MessageContainer";
import {WINDOW_POSTMESSAGE_TYPES} from "../App/constants";
import { postMessageToWindow } from 'utils/index';

const Home = props => {
  const {
    getUserConversations,
    userSettingBot,
    userSettings,
    userSettingColor,
    Language,
    userConversations,
    createNewConversation,
    isLoadingConversations,
    setActivePageStart,
    customCookies,
    setCurrentChannel,
    nativeNotification,
    userConfig,
    userData,
    currentChannel,
    hideCompanyDetailsInWidget,
    setNotificationRead,
    userAttachments,
    getAllFiles,
  } = props;

  useEffect(() => {
    const { eventListenerName } = userConfig;
    const event = {
      eventType: eventTypes.HOME_PAGE_LOADED,
      timestamp: Date.now(),
      url: userConfig ? userConfig.blogUrl : '',
      props: {},
    };
    saveEventToLocalStorage(event);
    getUserConversations();
    if(getFromLocalStorage(localStorageTemplates.widgetSessionActive) === 'true')
    {
      if(customCookies && Array.isArray(customCookies) && customCookies.length >0) {
        postMessageToWindow(
            {
              type: eventListenerName,
              event: WINDOW_POSTMESSAGE_TYPES.getCustomCookies,
              customCookies,
            },
            '*'
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [displayAllFiles, setDisplayAllFiles] = useState(false);

  const NewSessionTime = styled.div`
  text-align: center;
  font-size: 9px;
  color: #2F3C4E;
  mix-blend-mode: normal;
  opacity: 0.5;
  transform: translateY(10px);
  animation: ${slideUp} 0.2s ease-in-out 0.1s forwards;
  will-change: transform;
  font-style: italic;
  line-height: 11px;
  ${p => p.lead && 'text-align: right; padding-right: 0.25rem'}
  ${p => p.previousMessage && 'margin-top: 16px'}
  margin: 12px 0 8px 0;
  & time{
    opacity: 0.5;
  }
`;

  useEffect(()=>{
    if(displayAllFiles){
      let meta = {}
      getAllFiles({ meta: { cid: currentChannel } });
    }
  }, [displayAllFiles])

  const renderHomeHeader = () => {
    return (
      <HomeHeader textColor={userSettingColor ? userSettingColor.headerTextColor : ''}>
        {userSettingBot && userSettingBot.img && (
          <HeaderLogoContainer>
              <HomeHeaderCoyLogo src={userSettingBot.img} alt="coy-logo" />
              <MoreOptions
                Language={Language}
                setDisplayAllFiles={setDisplayAllFiles}
                shouldShowRestartConversation={false}
                disableFileSharing={userSettings.disableFileSharing}
                showInputBox={false}
                userSettingColor={userSettingColor}
              />
          </HeaderLogoContainer>
        )}

        {userSettingBot && userSettingBot.company && !hideCompanyDetailsInWidget && (
          <HomeHeaderTitle>{Language && Language.HomepageHeader && Language.HomepageHeader.toString().replace("{HomepageHeaderCompany}",DOMPurify.sanitize(userSettingBot.company))}</HomeHeaderTitle>
        )}

        {userSettingBot && userSettingBot.description && !hideCompanyDetailsInWidget && (
          <HomeHeaderSubtitle>{DOMPurify.sanitize(userSettingBot.description)}</HomeHeaderSubtitle>
        )}
        <HomeConversationHeader textColor={userSettingColor ? userSettingColor.headerTextColor : ''} hideCompanyDetailsInWidget={hideCompanyDetailsInWidget}>
          {Language && Language.HomepageYourConversations}
        </HomeConversationHeader>
      </HomeHeader>
    );
  };

  const renderHomeConversationsList = () => {
    return (
      <HomeConversation>
        {nativeNotification && nativeNotification.message && (
          <NotificationContainer>
            <NativeNotification {...nativeNotification} />
          </NotificationContainer>
        )}
        <HomeConversationList>
          {isLoadingConversations ? (
            <LoaderCardWrapper>
                <TypingIndicator
                  id="insent-typing-indicator"
                  color={userSettingColor? userSettingColor.headerBackgroundColor : theme.palette.primary}
                  />
            </LoaderCardWrapper>

          ) : userConversations && userConversations.length > 0 ? (
            <>
              {userConversations.map((convo, i) => {
                let isAttachment = false;
                let messageText = '',
                  name = userSettingBot.company || '';
                if (convo.msg) {
                  if (convo.msg.text) {
                    messageText = convo.msg.text;
                  } else if (convo.msg.event) {
                    messageText = convo.msg.event;
                  } else if (convo.msg.link) {
                    messageText =
                      convo.msg.link && convo.msg.link.title ? convo.msg.link.title : '';
                  } else if(convo.msg.attachments && convo.msg.attachments.length > 0){
                    isAttachment = true;
                    messageText = Array.isArray(convo.msg.attachments) && convo.msg.attachments.length > 0 && convo.msg.attachments[0].name
                  }
                }

                if (convo.members.length > 0) {
                  if (convo.members.length <= 2) {
                    name = convo.members[0].name;
                    if (convo.members.length > 1) {
                      name += ` & ${convo.members[1].name}`;
                    }
                  } else {
                    name = `${convo.members[0].name} & ${convo.members.length - 1} others`;
                  }
                }

                return (
                  <div key={convo.cid}>
                    <AgentCard
                      name={name}
                      message={messageText}
                      isAttachment={isAttachment}
                      members={convo.members}
                      time={convo.msg.time || 0}
                      onClick={() => {
                        setCurrentChannel({ channelId: convo.cid });
                        setActivePageStart(PAGE.CONVO);
                      }}
                      userSettingBot={userSettingBot}
                      userSettingColor={userSettingColor}
                    />
                  </div>
                );
              })}
            </>
          ) : (
            <NoConversation textColor={userSettingColor ? userSettingColor.headerTextColor : ''}>
              No active conversations
            </NoConversation>
          )}
        </HomeConversationList>
      </HomeConversation>
    );
  };

  const renderAllFiles = () => {
    return (
        <>
          <ConversationHeader>
            <ConversationBackButton onClick={() => setDisplayAllFiles(false)}>
              <ConversationBackIcon src={AllFilesBackIcon} alt="back button" />
            </ConversationBackButton>
            <AllFilesHeader>
              <AllFiles fill={"#000000"}></AllFiles>
              <AllFilesHeaderText>All Files</AllFilesHeaderText>
            </AllFilesHeader>
          </ConversationHeader>
          <AllFilesListContainer>
            {renderAllFilesList()}
          </AllFilesListContainer>
          <AllFilesFooter bgColor={userSettingColor ? userSettingColor.headerBackgroundColor : null}/>
        </>
    );
  }

  const renderAllFilesList = () => {
    let userAttachmentsDiv = userAttachments.map((ele, index) => {
          return (
              <>
                {
                  (index === 0 || moment(ele.createdAt).isSame(moment(userAttachments[index-1].createdAt))) &&
                  <NewSessionTime>
                    <Moment calendar={MOMENT_STRINGS} interval={10000} unix>
                      {ele.createdAt > MOMENT_TIME_LIMIT ? ele.createdAt / 1000 : ele.createdAt}
                    </Moment>
                  </NewSessionTime>
                }
                <FileItem
                    bgColor={userSettingColor ? userSettingColor.headerBackgroundColor : theme.palette.primary}
                    attachment={ele}
                />
              </>
          );
        }
    )
    return userAttachmentsDiv;
  }

  const homePageCloseAction = () => {
    const event = {
      eventType: eventTypes.HOME_PAGE_CLOSED,
      timestamp: Date.now(),
      url: userConfig ? userConfig.blogUrl : '',
      props: {},
    };
    setNotificationRead(0);
    saveToLocalStorage(localStorageTemplates.notificationRead, 0);
    saveEventToLocalStorage(event);
    setActivePageStart(PAGE.LAUNCHER);
  };

  const renderEntireHomePage = () => {
    return (
      <>
        <HomeContainer id="insent-home-container">
        <HomeBackgroundSVG id="insent-home-background-svg" viewBox="0 0 360 349" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 20C0 8.9543 8.95431 0 20 0H340C351.046 0 360 8.95431 360 20V186.051C360 194.132 355.137 201.419 347.675 204.52L0 349V20Z"
              fill={userSettingColor ? userSettingColor.headerBackgroundColor : ''}
          />
        </HomeBackgroundSVG>
        <HomeBg id="insent-home-bg" />
        {renderHomeHeader()}
        {renderHomeConversationsList()}
        </HomeContainer>
        <MessageInput
          Language={Language}
          placeholder="New Conversation"
          bgColor={userSettingColor ? userSettingColor.headerBackgroundColor : ''}
          textColor={userSettingColor ? userSettingColor.headerTextColor : ''}
          buttonClick={createNewConversation}
          type="footer"
        />
      </>
    );
  }

  return (
    <>
      <Card
        id="insent-home-card"
        onClose={homePageCloseAction}
        height="calc(100vh - 78px)"
        zIndex={1}
        textColor={userSettingColor ? userSettingColor.headerTextColor : ''}
      >
        {!displayAllFiles && renderEntireHomePage()}
        {displayAllFiles && renderAllFiles()}
      </Card>
      <InsentLink show={userData?userData.settings?userData.settings.showPoweredByInsentText:true:true} privacyPolicy={userData?.privacyPolicy}/>
    </>
  );
};

Home.propTypes = {};

export const mapStateToProps = (state, props) => {
  return createStructuredSelector({
    userData: globalSelectors.makeSelectCurrentUser(),
    userSettings: globalSelectors.makeSelectCurrentUserSettings(),
    Language: globalSelectors.makeSelectLanguage(),
    customCookies: globalSelectors.makeSelectCustomCookies(),
    userSettingColor: globalSelectors.makeSelectCurrentUserSettingColor(),
    userSettingBot: globalSelectors.makeSelectCurrentUserSettingBot(),
    hideCompanyDetailsInWidget: globalSelectors.makeSelectHideCompanyDetailsInWidget(),
    userConversations: globalSelectors.makeSelectCurrentUserConversations(),
    isLoadingConversations: globalSelectors.makeSelectIsLoadingCurrentUserConversations(),
    userAttachments: globalSelectors.makeSelectUserAttachments(),
  });
};

export const mapDispatchToProps = dispatch => {
  return {
    getUserConversations: () => dispatch(globalActions.getUserConversationsList.start()),
    createNewConversation: () => dispatch(globalActions.createNewConversation.start()),
    setActivePageStart: page => dispatch(globalActions.setActivePage.start(page)),
    getAllFiles: ({meta}) => dispatch(globalActions.getAllFiles.start({meta})),
    setCurrentChannel: ({ channelId }) => dispatch(globalActions.setCurrentChannel({ channelId })),
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(Home);
